/**
 * @file
 * Message class used to present messages.
 */

import * as React from 'react';

// Config
import { DEFAULT_STRING_NO_TABLE_RESULTS } from '../../config';

interface IProps {
  // Custom class that is used to add to div wrappers.
  customClass: string;
  // The message string to be displayed.
  message: string;
  // Determines if message should show or not.
  shouldShow: boolean;
}

class Message extends React.PureComponent<IProps> {
  public static defaultProps = {
    message: DEFAULT_STRING_NO_TABLE_RESULTS,
    shouldShow: true,
  };

  public render() {
    const { customClass, message, shouldShow } = this.props;

    return (
      <>
        {shouldShow && (
          <div
            className={`${customClass} leaderboard-list__message`}
            data-testid="message-component"
          >
            <p data-testid="message">{message}</p>
          </div>
        )}
      </>
    );
  }
}

export default Message;
